import { getUserId } from '@/services/identity-client'
import { useLayers } from '@/services/layer-management-service/composables/use-layers'
import { toggleUserLayerActive } from '@/services/layer-management-service/initialize'

/**
 * Migrating layer-management basemap data from browser local storage, to
 * cloud persistence.
 */
export const migrateBasemaps = async () => {
  const app = 'fish'
  const userId = await getUserId()
  const namespace = `onx.lms.${app}.${userId}`
  const layersKey = `${namespace}.layers`

  // pulling data out of the built-in browser local storage
  const layerSettings: Record<string, boolean> = JSON.parse(
    localStorage.getItem(layersKey) || '{}'
  )

  // bail if nothing in local storage
  if (!Object.keys(layerSettings).length) {
    return
  }

  // get basemap related user layer ids
  const { getUserLayerIdsByTag } = useLayers()
  const keys = [
    ...getUserLayerIdsByTag('basemaps'),
    ...getUserLayerIdsByTag('basemap-toggles'),
  ]

  // if any are set to true, toggle them on
  // this will flow through to cloud persistence
  for (const key of keys) {
    if (layerSettings[key] === true) {
      toggleUserLayerActive(key, true)
    }
  }

  // nuke local storage, so migration is only done once
  for (const key of Object.keys(localStorage)) {
    if (key.startsWith(namespace)) {
      localStorage.removeItem(key)
    }
  }
}
